import React, { useState, useEffect } from 'react';
import ContactService from './ContactService';
import Alert from 'react-bootstrap/Alert';
import filterFieldsForList from '../common/functions/filterFieldsForList';
import filterDataForList from '../common/functions/filterDataForList';
import schema from './jsonSchema';
import AdvanceList from '../common/AdvanceList';
import { Link, useNavigate } from 'react-router-dom';
import useHeaderGenerator from '../common/functions/useHeaderGenerator';

const ContactList = () => {
  const [data, setData] = useState();
  const [columns, setColumns] = useState([]);
  const [error, setError] = useState('');
  const [noDataToShow, setNoDataToShow] = useState(true);
  const navigate = useNavigate();
  const transformData = (attr, item) => {
    if (attr === 'name') {
      const url = '/app/contacts/' + item['identifier'];
      return <Link to={url}>{item[attr]}</Link>;
    }
    console.log(item[attr]);
    return item[attr];
  };
  useEffect(() => {
    const jsonSchema = schema;
    const fieldsForList = filterFieldsForList(jsonSchema);
    setColumns(fieldsForList);

    ContactService.retrieveAllContactsByAccount()
      .then(data => {
        console.log(data);
        setData(filterDataForList(
            data,
            columns.map(c => c.accessor),
            transformData
          ));
        setNoDataToShow(!data.length > 0);
      })
      .catch(error => setError({ error: error.message }));
  }, [noDataToShow]);
  const buttonsConf = [
    {
      name: 'Add Contact',
      type: 'submit',
      variant: 'info',
      icon: 'plus',
      onClick: () => {
      console.log('Create a new Contact');
      navigate('/app/contacts/create-form');
      }
    }
  ];
  const description = 'Here you can find all your contacts. You can create, edit and delete them. Click on a contact to see more details about it.';
  const headerGenerated = useHeaderGenerator(
    'Contacts',
    description,
    buttonsConf
  );
  return (
    <>
    {headerGenerated}

      {noDataToShow && (
        <Alert key="warning" variant="warning">
          There's not any Contact to show. Let's create a new one!
        </Alert>
      )}
      {data && (
        <AdvanceList columns={columns} data={data} />
      )}
    </>
  );
};

export default ContactList;